import React from "react";
import { GoogleOAuthProvider } from "@react-oauth/google";

/**
 * Keep the dashboard usable when Google sign-in is not configured.
 *
 * @react-oauth/google throws during render for an empty clientId. Email/OTP
 * authentication does not depend on Google OAuth, so a missing optional
 * provider must not crash the entire application.
 */
const OptionalGoogleOAuthProvider = ({ children, clientId }) => {
  const normalizedClientId = typeof clientId === "string" ? clientId.trim() : "";

  if (!normalizedClientId) {
    return <>{children}</>;
  }

  return (
    <GoogleOAuthProvider clientId={normalizedClientId}>
      {children}
    </GoogleOAuthProvider>
  );
};

export default OptionalGoogleOAuthProvider;
